module.exports = __webpack_public_path__ + "static/media/logo.2542fb94.svg";